import { render, staticRenderFns } from "./kaoshiZj.vue?vue&type=template&id=a5eea088&scoped=true"
import script from "./kaoshiZj.vue?vue&type=script&lang=js"
export * from "./kaoshiZj.vue?vue&type=script&lang=js"
import style0 from "./kaoshiZj.vue?vue&type=style&index=0&id=a5eea088&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../youyidian_pc/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5eea088",
  null
  
)

export default component.exports